export const pushDataLayer = (data: object) => {
  window.dataLayer.push(data);
};
